<template>
  <div>
    <div class="invoice-basic">
      <van-cell-group v-show="invoiceInfo.ocrSellerName" :border="false">
        <van-field
          label="销方名称"
        >
          <p slot="input" class="input">{{invoiceInfo.checkFlag == 1 ? invoiceInfo.sellerName : invoiceInfo.ocrSellerName}}</p>
        </van-field>
      </van-cell-group>
      <van-cell-group v-show="invoiceInfo.ocrDrewDate" :border="false">
        <van-field
          label="开票日期"
        >
          <p slot="input" class="input">{{invoiceInfo.ocrDrewDate}}</p>
        </van-field>
      </van-cell-group>
      <van-cell-group v-show="invoiceInfo.drewDate && !invoiceInfo.ocrDrewDate" :border="false">
        <van-field
          label="开票日期"
        >
          <p slot="input" class="input">{{invoiceInfo.drewDate}}</p>
        </van-field>
      </van-cell-group>
      <van-cell-group v-show="invoiceInfo.invoiceCode" :border="false">
        <van-field
          label="发票代码"
        >
          <p slot="input" class="input">{{invoiceInfo.ocrInvoiceCode || invoiceInfo.invoiceCode}}</p>
        </van-field>
      </van-cell-group>
      <van-cell-group v-show="invoiceInfo.invoiceNo || invoiceInfo.ocrInvoiceNo" :border="false">
        <van-field
          label="发票号码"
        >
          <p slot="input" v-if="invoiceInfo.invoiceNo" class="input">{{invoiceInfo.invoiceNo}}</p>
          <p slot="input" v-if="!invoiceInfo.invoiceNo" class="input">{{invoiceInfo.ocrInvoiceNo}}</p>
        </van-field>
      </van-cell-group>
      <van-cell-group v-show="invoiceInfo.checkCode" :border="false">
        <van-field
          label="校验码"
        >
          <p slot="input" class="input">{{invoiceInfo.checkCode}}</p>
        </van-field>
      </van-cell-group>
    </div>
    <div class="divider-custom"></div>
    <div @click="openSellerInfo" v-if="invoiceInfo.checkFlag && (invoiceInfo.invoiceType === '01' || invoiceInfo.invoiceType === '04' || invoiceInfo.invoiceType === '10' || invoiceInfo.invoiceType === '11')" class="seller-info-wrp">
      <p class="title">
        <span style="font-size: 14px">购销方信息</span>
        <van-icon v-show="!openSeller" style="font-size: 12px" name="arrow-down" />
        <van-icon v-show="openSeller" style="font-size: 12px" name="arrow-up" />
      </p>
      <div v-show="openSeller">
        <van-cell-group :border="false">
          <van-field
            label="销方名称"
          >
            <p slot="input" class="input">{{invoiceInfo.sellerName}}</p>
          </van-field>
        </van-cell-group>
        <van-cell-group :border="false">
          <van-field
            label="销方税号"
          >
            <p slot="input" class="input">{{invoiceInfo.sellerTaxNo}}</p>
          </van-field>
        </van-cell-group>
        <van-cell-group :border="false">
          <van-field
            label="地址/电话"
          >
            <p slot="input" class="input">{{invoiceInfo.sellerAddressTel}}</p>
          </van-field>
        </van-cell-group>
        <van-cell-group :border="false">
          <van-field
            label="开户行/账号"
          >
            <p slot="input" class="input">{{invoiceInfo.sellerBankNameAcc}}</p>
          </van-field>
        </van-cell-group>
        <van-divider />
        <van-cell-group :border="false">
          <van-field
            label="购方名称"
          >
            <p slot="input" class="input">{{invoiceInfo.purchaserName}}</p>
          </van-field>
        </van-cell-group>
        <van-cell-group :border="false">
          <van-field
            label="购方税号"
          >
            <p slot="input" class="input">{{invoiceInfo.purchaserTaxNo}}</p>
          </van-field>
        </van-cell-group>
        <van-cell-group :border="false">
          <van-field
            label="地址/电话"
          >
            <p slot="input" class="input">{{invoiceInfo.purchaserAddressTel}}</p>
          </van-field>
        </van-cell-group>
        <van-cell-group :border="false">
          <van-field
            label="开户行/账号"
          >
            <p slot="input" class="input">{{invoiceInfo.purchaserBank}}</p>
          </van-field>
        </van-cell-group>
      </div>
    </div>
    <div class="divider-custom"></div>
    <div class="invoice-detail" v-if="type === 1">
      <p class="title">
        <span style="font-size: 14px">商品明细</span>
      </p>
      <div class="detail-title">
        <div class="name">品名</div>
        <div class="price">单价</div>
        <div class="count">数量</div>
        <div class="sum">金额</div>
      </div>
      <div
        v-show="consumerDetails.length"
        v-for="(val, key) in consumerDetails"
        :key="key"
        class="detail-item"
      >
        <div class="name">{{val.goodsName}}</div>
        <div class="price">{{convertNumber(val.unitPrice)}}</div>
        <div class="count">{{val.quantity}}</div>
        <div class="sum">{{convertNumber(val.amount)}}</div>
      </div>
      <div class="divider-custom"></div>
      <div class="detail-item" v-show="!consumerDetails.length">
        无明细信息
      </div>
      <!-- <div style="text-align:center;color: #666666" v-show="consumerDetails.length > 5">
        ...
      </div> -->
    </div>
    <van-cell-group :border="false">
      <van-field
        label="发票金额"
      >
        <p slot="input" class="input" style="color: #2196F3;font-weight:bold">¥{{convertNumber(invoiceInfo.amountWithTax)}}</p>
      </van-field>
    </van-cell-group>
    <van-cell-group :border="false">
      <van-field
        label="发票税额"
      >
        <p slot="input" class="input" style="color: #2196F3;font-weight:bold">{{invoiceInfo.taxAmount ? `¥${convertNumber(invoiceInfo.taxAmount)}` : `¥0`}}</p>
      </van-field>
    </van-cell-group>
    <van-cell-group :border="false">
      <van-field
        label="不含税金额"
      >
        <p slot="input" class="input" style="color: #2196F3;font-weight:bold">¥{{convertNumber(invoiceInfo.amount)}}</p>
      </van-field>
    </van-cell-group>
    <div class="divider-custom"></div>
    <van-cell-group :border="false">
      <van-field
        label="备注"
      >
        <div slot="input" class="input">{{invoiceInfo.customRemark}}</div>
      </van-field>
    </van-cell-group>
    <van-cell-group :border="false">
      <van-field
        label="标签"
      >
        <div slot="input" class="input">{{invoiceInfo.tag}}</div>
      </van-field>
    </van-cell-group>
  </div>
</template>

<script>
import {
  CellGroup,
  Field,
  Divider,
  Icon
} from 'vant'
import { ConvertNumber } from '@utils/basicUtil'
export default {
  props: {
    invoiceInfo: {
      type: Object
    },
    type: {
      type: Number
    },
    consumerDetails: {
      type: Array
    }
  },
  data: () => ({
    openSeller: false
  }),
  mounted () {
  },
  methods: {
    convertNumber (data) {
      return ConvertNumber(data)
    },
    openSellerInfo () {
      this.openSeller = !this.openSeller
    }
  },
  components: {
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [Divider.name]: Divider,
    [Icon.name]: Icon
  }
}
</script>

<style lang="less" scoped src="./style.less"/>
